module.exports = __webpack_public_path__ + "Flag-788.2fce24356d4ceffba4e6c28d5caf3fe0.svg";